module.exports = __webpack_public_path__ + "static/media/avatar.2159114d.svg";